'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './bulletin-edit.routes';

export class BulletinEditComponent {
  /*@ngInject*/
  constructor(BulletinService, Auth, $stateParams, $state, $location, dialogs, $uibModal, StorageService, Upload, $q, Config) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Auth = Auth;
    this.BulletinService = BulletinService;
    this.StorageService = StorageService;
    this.toolbarDefinition = [
      ["bold","italics","underline","strikeThrough"],
      ["h3","h4","h5"],
      ["p","pre","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["indent","outdent"],
      ["undo","redo"],
      ["html"],
      ["insertImage","insertLink","insertVideo"]
    ];

    this.bulletinId = $stateParams.id;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Bulletin Board Post");

    // Enumeration with possible categories
    this.categoryOptions = Config.getModuleConfig(Config.Modules.Bulletin).getCategories();

    //TODO: fetch default from settings / split categories ??
    this.categoryMajor = this.categoryOptions[0];
    this.categoryMinor = this.categoryOptions[2];

    this.$state = $state;
    this.$location = $location;
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.Upload = Upload;
    this.$q = $q;

    this.userIsRealtor = Auth.getCurrentUserSync().role.indexOf("realtor") > -1;

    this.bulletinTemplate = {
      title: '',
      description: '',
      contact: '',
      isPublic: false,
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    if (this.userIsRealtor) {
      //TODO: retrieve default condo/poa/property category from settings
      this.categoryMinor = this.categoryOptions[this.categoryOptions.length-1];
      this.bulletinTemplate.isPublic = true;

      let realtor = Auth.getCurrentUserSync();
      this.bulletinTemplate.contact = [
        realtor.firstName + ' ' + realtor.lastName,
        'Phone: ' + (realtor.profile.phone[0].number || '-'),
        realtor.profile.about
      ].join('\n');

      this.pageTitle = "Listing";
    }

    this.bulletin = angular.copy(this.bulletinTemplate);
    this.assets = [];

    if (this.bulletinId) {
      this.BulletinService.get({id: this.bulletinId}, data => {
        this.bulletin = data;
        this.assets = data.attachments;

        this.categoryMajor = this.bulletin.categories[0] || this.categoryOptions[0];
        this.categoryMinor = this.bulletin.categories[1] || this.categoryOptions[2];
      }, err => {
        console.log('Could not load bulletin board post from server');
      })
    }
      
    var that = this;

    this.dropHandler = function( file, insertAction ) {

        var isImage = that.isImageMime(file.type);
        var isPdf = that.isPdfMime(file.type);

        // validation
        if( !isImage && !isPdf) {
            // ignore other file than images and pdfs
            return;
        }

      /* could check for file size: if( file.size > 500000 ) */

        var defer = that.$q.defer();

        that.Upload.upload({
            url: '/api/storage',
            data: {
                name: file.name,
                file: file,
                storageStrategy: 'local',
                isPublic: true,
                creationUser: that.Auth.getCurrentUserSync()._id,
                active: true
            }
        }).then((response) => {

            if (isImage) {
                insertAction( "insertImage", "/api/storage/" + response.data, true );
                defer.resolve(true);
            } else if (isPdf) {
                that.StorageService.getMeta({id: response.data}, data => {
                    that.assets.push(data);
                    defer.resolve(true);
                }, err => {
                    console.log('could not retrieved storage from server');
                    defer.reject();
                });
            }

        }, (response) => {
            if (response.status > 0) {
                alert(response.status + ': ' + response.data);
                defer.reject();
            }
        });

        return defer.promise;

    };
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  removeAsset(idx) {
    // Check if the removed image is going to be the feature image
    var featureImageRemoved = this.assets[idx]._id == this.bulletin.featureImage;

    // remove the image
    this.assets.splice(idx,1);

    if (featureImageRemoved) {
      delete this.bulletin.featureImage;
    }
  }

  checkValidUntilDate(date) {
    if (new Date(date).getTime() < (new Date().getTime())) {
      return "The expiration date must not be in the past"
    }
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = data => {
        this.bulletin = angular.copy(this.bulletinTemplate);
        this.submitted = false;

        var id = that.bulletinId || data._id;

        var actionString = (this.bulletinId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "Your bulletin board post has been "+actionString+" successfully");
        dlg.result.then(() => {
          if (id) {
            let view = (this.userIsRealtor) ? "listing" : "bulletin";
            that.$location.path("/"+view+"/" + id);
          } else if (this.userIsRealtor) {
            that.$state.go("bulletin-realtor");
          } else {
            that.$state.go("bulletin-list");
          }
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.bulletin.attachments = this.assets.map(asset => {
        return asset._id;
      });

      this.bulletin.categories = [this.categoryMajor, this.categoryMinor];

      if (this.bulletinId) {  // Save changes on the current bulletin board entry
        this.BulletinService.update({id: this.bulletinId}, this.bulletin, onSuccess, onError);
      } else { // Create a new bulletin board entry
        this.BulletinService.save(this.bulletin, onSuccess, onError);
      }
    }
  }

  openAssetBrowserModal = function () {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {
            restrictToUserAssets: !that.Auth.isAdminSync(),
            userId: that.Auth.getCurrentUserSync()._id
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newlySelectedAssets) {
        that.assets = that.assets.concat(newlySelectedAssets);
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal = function () {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'application/pdf,image/*'
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        result.forEach(storageId => {
          that.StorageService.getMeta({id: storageId}, data => {
            that.assets.push(data);
          }, err => {
            console.log('could not retrieved storage from server');
          });

        });

      },
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduuApp.bulletinEdit', [uiRouter])
  .config(routes)
  .component('bulletinEdit', {
    template: require('./bulletin-edit.html'),
    controller: BulletinEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/bulletin/edit/bulletin-edit.component.js